import _ from 'lodash';
import {LOCATION_CHANGE} from 'react-router-redux';
import {
  activateBoundary,
  activateOverlay,
  error,
  openGraphsView,
  selectDataSet,
  setActivateIncidentWhenLoaded,
  setActivePoint,
  setActivePrescription,
  setAppMode,
  setGraphsExpanded,
  setMapBoundsAndZoom,
  setMapCenter,
  setPopOut,
  setTableBackground,
  setTableDirections,
  setUrl,
  setUrlHash,
  switchIndicators,
  togglePointDataDisplay
} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {buildUrlHash, getParamsFromUrl} from '../utils/url_utils';

// Returns the first element of a set.
export const _first = (set) => {
  if (set && set.size) {
    return set.values().next().value;
  }
  return null;
};

export const buildUrlHashFromState = (state) => {
  return buildUrlHash(
    state.indicators.indicators.filter(indicator => indicator.active === true),
    state.boundaries.layers.filter(layer => layer.active === true),
    state.overlays.layers.filter(layer => layer.active === true),
    state.point,
    state.map.map_zoom,
    state.map.map_center,
    state.view.popup_open,
    state.view.graphs_open,
    state.view.graph_view_expanded,
    state.view.pop_out,
    state.view.print_on_load,
    state.app.app_mode,
    state.view.point_data_display_graph,
    state.graphs.data_set,
    state.graphs.table_background,
    state.graphs.table_directions,
    state.incidents.active,
    state.point_data_prescriptions.prescription);
};

export const location = store => next => action => {
  // First complete the current action
  const result = next(action);

  switch (action.type) {
    case ActionTypes.POPULATE_AWS_DATA:
      // Once the AWS stations are loaded, check if there is a station_id on the query string. If there is, jump to
      // that station.
      const query_string_station_id = store.getState().app.query_string_station_id;
      if (query_string_station_id && action.data && action.data.features) {
        const station = _.find(action.data.features, o => _.get(o, 'properties.stationid') === query_string_station_id);
        if (station) {
          const station_coords = station.geometry.coordinates;
          store.dispatch(setMapBoundsAndZoom(undefined, 10));
          store.dispatch(setActivePoint(station_coords[1], station_coords[0]));
          store.dispatch(setMapCenter(station_coords[1], station_coords[0]));
          store.dispatch(openGraphsView());
        } else {
          store.dispatch(error('Weather station not found with ID: ' + query_string_station_id));
        }
      }
      break;

    case ActionTypes.TOGGLE_OVERLAY:
    case ActionTypes.TOGGLE_BOUNDARY:
    case ActionTypes.SWITCH_ACTIVE_INDICATOR:
    case ActionTypes.SET_ACTIVE_POINT:
    case ActionTypes.SET_ACTIVE_INCIDENT_FEATURE:
    case ActionTypes.SET_ACTIVE_PRESCRIPTION:
    case ActionTypes.SET_BEHAVIOUR_VARIABLES:
    case ActionTypes.CLOSE_POPUP:
    case ActionTypes.SET_MAP_BOUNDS_AND_ZOOM:
    case ActionTypes.OPEN_GRAPHS_VIEW:
    case ActionTypes.TOGGLE_GRAPHS_EXPANDED:
    case ActionTypes.SET_GRAPHS_EXPANDED:
    case ActionTypes.SET_APP_MODE:
      if (!action.src_location_change) {
        store.dispatch(setUrl());
      }
      break;

    case LOCATION_CHANGE:
      const params = getParamsFromUrl(action.payload);
      if (params['i']) {
        store.dispatch(switchIndicators(_first(params['i']), true));
      }
      if (params['b']) {
        params['b'].forEach(value => store.dispatch(activateBoundary(value, true, true)));
      }
      if (params['o']) {
        params['o'].forEach(value => store.dispatch(activateOverlay(value, true, true)));
      }
      if (params['plat'] && params['plng']) {
        const plat = parseFloat(_first(params['plat']));
        const plng = parseFloat(_first(params['plng']));
        const popup_open = _first(params['pp']) === 'true';

        store.dispatch(setActivePoint(plat, plng, popup_open, true));
        if (!(params['clat'] && params['clng'])) {
          store.dispatch(setMapCenter(plat, plng, true));
        }
      }
      if (params['clat'] && params['clng']) {
        const clat = parseFloat(_first(params['clat']));
        const clng = parseFloat(_first(params['clng']));
        if (clat && clng) {
          store.dispatch(setMapCenter(clat, clng, true));
        }
      }
      if (params['z']) {
        store.dispatch(setMapBoundsAndZoom(null, _first(params['z']), true));
      }
      if (params['go']) {
        store.dispatch(openGraphsView(true));
      }
      if (params['ge']) {
        store.dispatch(setGraphsExpanded(true, true));
      }
      if (params['po']) {
        store.dispatch(setPopOut(false));
      }
      if (params['dt']) {
        store.dispatch(togglePointDataDisplay());
      }
      if (params['pr']) {
        store.dispatch(setPopOut(true));
      }
      if (params['am']) {
        store.dispatch(setAppMode(_first(params['am']), true));
      }
      if (params['ds']) {
        store.dispatch(selectDataSet(_first(params['ds'])));
      }
      if (params['tb']) {
        store.dispatch(setTableBackground(_first(params['tb'])));
      }
      if (params['td']) {
        store.dispatch(setTableDirections(_first(params['td'])));
      }
      if (params['bid']) {
        const eventId = Number(_first(params['bid']));
        if (eventId) {
          store.dispatch(setActivateIncidentWhenLoaded(eventId));
        }
      }
      if (params['pid']) {
        store.dispatch(setActivePrescription(_first(params['pid']), true));
      }
      break;

    case ActionTypes.SET_URL:
      const state = store.getState();
      const url_hash = buildUrlHashFromState(state);
      if (url_hash !== state.routing.url_hash) {
        store.dispatch(setUrlHash(url_hash));
      }
      break;

    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/locationMiddleware.js